/*
 * @Date: 2026-01-31 10:00:00
 * @Description: 活动相关API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 活动信息
  getActivityInfo(data) {
    return request({
      url: "/activity/getActivityInfo?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 提交表单
  submitForm(data) {
    return request({
      url: "/parties/submitForm",
      method: "post",
      data,
    });
  },
  // 获取一级（省）
  getFirstCodes(data) {
    return request({
      url: "/parties/getFirstCodes?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取二级（市）
  getAreaInfoByFirstCode(data) {
    return request({
      url: "/parties/getAreaInfoByFirstCode?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取三级（区）
  getAreaInfoBySecondCode(data) {
    return request({
      url: "/parties/getAreaInfoBySecondCode?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 地区列表
  getAreaInfoList(data) {
    return request({
      url: "/parties/getAreaInfoList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
};
